import React, { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import styles from '../EventAgenda.module.scss'

export const CurrentTimeIndicator = ({
  gridColumns,
  onUpdate,
  currentTime
}) => {
  const getMinutesFromMidnight = (date) => {
    const d = new Date(date)
    return d.getUTCHours() * 60 + d.getUTCMinutes()
  }

  const updatePosition = useCallback(() => {
    const now = new Date() // new Date() // Current time
    const totalMinutes = 1440 // Total minutes in a day
    const currentMinutes = getMinutesFromMidnight(now)

    const c1 = Math.floor((currentMinutes / totalMinutes) * gridColumns) + 1
    const c2 = c1 + 1 // Assuming the current time spans one column
    onUpdate({ c1, c2 })
  }, [gridColumns, onUpdate])

  useEffect(() => {
    updatePosition()
    const interval = setInterval(updatePosition, 60000) // Update every minute
    return () => clearInterval(interval)
  }, [updatePosition])

  return (
    <div
      className={styles.CurrentTimeIndicator}
      style={{
        gridColumn: `${currentTime.c1} / span ${currentTime.c2}`,
        gridRow: '1 / -1'
      }}
    />
  )
}

CurrentTimeIndicator.propTypes = {
  gridColumns: PropTypes.number.isRequired,
  onUpdate: PropTypes.func.isRequired,
  currentTime: PropTypes.shape({
    c1: PropTypes.number,
    c2: PropTypes.number
  })
}
